import { baseNamedEntityModel } from './base';

export const HolidayCultureOptions = ['EN_US', 'ES_ES'] as const;
export type HolidayCulture = (typeof HolidayCultureOptions)[number];

export interface holidayModel extends baseNamedEntityModel {
  date?: Date;
  culture?: HolidayCulture;
}
